/* ============================================================
   Passi nei Sassi — home page behaviours
   Reviews carousel · review lightbox · interactive map
   (Header / drawer / reveal live in pns-chrome.js.)
   ============================================================ */
(function () {
  'use strict';

  /* ---------- reviews carousel ---------- */
  (function () {
    var track = document.getElementById('revTrack');
    if (!track) return;
    var prev = document.querySelector('.rev-arrow.prev');
    var next = document.querySelector('.rev-arrow.next');

    function step(dir) {
      var card = track.querySelector('.rev-summary, .rev-card');
      var gap = parseInt(getComputedStyle(track).gap, 10) || 16;
      var w = card ? card.getBoundingClientRect().width + gap : 320;
      track.scrollBy({ left: dir * w * 2, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    function updateArrows() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.toggleAttribute('disabled', track.scrollLeft <= 2);
      next.toggleAttribute('disabled', track.scrollLeft >= max);
    }
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    track.addEventListener('click', function (e) {
      var more = e.target.closest('.rev-more');
      if (!more) return;
      var card = more.closest('.rev-card');
      if (!card) return;
      var expanded = card.classList.toggle('expanded');
      more.textContent = expanded ? 'Mostra meno' : 'Mostra di più';
    });
  })();

  /* ---------- review photo lightbox ---------- */
  (function () {
    var photos = document.querySelectorAll('.rev-photo');
    if (!photos.length) return;
    var overlay = null;
    function open(src) {
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'rev-lightbox';
        overlay.innerHTML = '<button class="rev-lightbox-close" aria-label="Chiudi">&times;</button><img alt="Foto recensione" />';
        document.body.appendChild(overlay);
        overlay.addEventListener('click', function (e) {
          if (e.target === overlay || e.target.classList.contains('rev-lightbox-close')) close();
        });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      }
      overlay.querySelector('img').src = src;
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      if (overlay) overlay.classList.remove('open');
      document.body.style.overflow = '';
    }
    photos.forEach(function (p) {
      p.addEventListener('click', function () {
        var bg = p.style.backgroundImage.match(/url\(['"]?(.+?)['"]?\)/);
        if (bg) open(bg[1]);
      });
    });
  })();

  /* ---------- interactive map ---------- */
  (function () {
    var root = document.getElementById('mapGrid');
    if (!root) return;

    var TOURS = {};
    var dataEl = document.querySelector('[data-map-tours]');
    if (dataEl) { try { TOURS = JSON.parse(dataEl.textContent); } catch (e) { TOURS = {}; } }

    var detail = document.getElementById('mapDetail');
    var pins = root.querySelectorAll('.map-pin');
    var zones = root.querySelectorAll('.map-zone');
    var items = root.querySelectorAll('.map-tour');
    var ORDER = Array.prototype.map.call(items, function (it) { return it.dataset.tour; });

    function renderDetail(key) {
      var t = TOURS[key];
      if (!t || !detail) return;
      detail.innerHTML =
        '<div class="map-detail-head">' +
          '<span class="map-detail-eyebrow">' + (t.eyebrow || '') + '</span>' +
          '<span class="map-detail-price">' + (t.price || '') + '</span>' +
        '</div>' +
        '<h3 class="map-detail-title">' + (t.title || '') + '</h3>' +
        '<p class="map-detail-desc">' + (t.desc || '') + '</p>' +
        '<div class="map-detail-foot">' +
          '<span class="map-detail-stops">' + (t.stops || '') + '</span>' +
          '<a class="map-detail-cta" href="' + (t.href || '#') + '">Vedi tour' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>' +
          '</a>' +
        '</div>';
      detail.classList.remove('swap');
      void detail.offsetWidth;
      detail.classList.add('swap');
    }

    var userInteracted = false;
    var cycleTimer = null;

    function setActive(key, opts) {
      opts = opts || {};
      root.setAttribute('data-active', key);
      items.forEach(function (it) {
        var on = it.dataset.tour === key;
        it.classList.toggle('active', on);
        it.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      renderDetail(key);
      if (opts.userTriggered) userInteracted = true;
    }

    function startCycle() {
      stopCycle();
      if (ORDER.length < 2) return;
      cycleTimer = setInterval(function () {
        if (userInteracted) return stopCycle();
        var cur = root.getAttribute('data-active');
        var nextKey = ORDER[(ORDER.indexOf(cur) + 1) % ORDER.length];
        setActive(nextKey);
      }, 4500);
    }
    function stopCycle() { if (cycleTimer) { clearInterval(cycleTimer); cycleTimer = null; } }

    pins.forEach(function (p) {
      p.addEventListener('click', function () { setActive(p.dataset.tour, { userTriggered: true }); });
      p.addEventListener('mouseenter', function () { if (!userInteracted) setActive(p.dataset.tour); });
    });
    zones.forEach(function (z) {
      z.addEventListener('click', function () { setActive(z.dataset.tour, { userTriggered: true }); });
      z.addEventListener('mouseenter', function () { if (!userInteracted) setActive(z.dataset.tour); });
    });
    items.forEach(function (it) {
      it.addEventListener('click', function () { setActive(it.dataset.tour, { userTriggered: true }); });
      it.addEventListener('mouseenter', function () { if (!userInteracted) setActive(it.dataset.tour); });
    });
    root.addEventListener('mouseenter', stopCycle);
    root.addEventListener('mouseleave', function () { if (!userInteracted) startCycle(); });

    if ('IntersectionObserver' in window) {
      var visIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !userInteracted) startCycle();
          else stopCycle();
        });
      }, { threshold: 0.3 });
      visIo.observe(root);
    }

    renderDetail(root.getAttribute('data-active') || ORDER[0]);
  })();
})();
